"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.THEME_PATH = exports.EVOLUTION_STATE_STYLES = exports.DEFAULT_STYLING_CONSTANTS = exports.BUTTON_LIGHTEN_AMOUNT = exports.BUTTON_DARKEN_AMOUNT = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _lodash = require("lodash");
var _stylingConstants = _interopRequireDefault(require("@gravity/styling-constants"));
var _themeMapper = require("@gravity/theme-mapper");
var _themeProvider = require("@gravity/theme-provider");
var _utils = require("@gravity/utils");
var _helpers = require("./helpers");
var _types = require("./types");
var _templateObject;
function cov_1eiaa68uz9() {
  var path = "/codebuild/output/src3108803385/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Button/lib/constants.js";
  var hash = "950ed8eaec4aa9e107d4c4cac44a9e8ef570e703";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src3108803385/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Button/lib/constants.js",
    statementMap: {
      "0": {
        start: {
          line: 11,
          column: 10
        },
        end: {
          line: 11,
          column: 34
        }
      },
      "1": {
        start: {
          line: 12,
          column: 41
        },
        end: {
          line: 12,
          column: 57
        }
      },
      "2": {
        start: {
          line: 13,
          column: 19
        },
        end: {
          line: 13,
          column: 33
        }
      },
      "3": {
        start: {
          line: 15,
          column: 37
        },
        end: {
          line: 15,
          column: 40
        }
      },
      "4": {
        start: {
          line: 17,
          column: 36
        },
        end: {
          line: 17,
          column: 39
        }
      },
      "5": {
        start: {
          line: 19,
          column: 26
        },
        end: {
          line: 25,
          column: 1
        }
      },
      "6": {
        start: {
          line: 27,
          column: 41
        },
        end: {
          line: 46,
          column: 1
        }
      },
      "7": {
        start: {
          line: 48,
          column: 29
        },
        end: {
          line: 52,
          column: 3
        }
      },
      "8": {
        start: {
          line: 48,
          column: 40
        },
        end: {
          line: 52,
          column: 3
        }
      },
      "9": {
        start: {
          line: 49,
          column: 2
        },
        end: {
          line: 52,
          column: 3
        }
      },
      "10": {
        start: {
          line: 54,
          column: 38
        },
        end: {
          line: 61,
          column: 1
        }
      },
      "11": {
        start: {
          line: 56,
          column: 14
        },
        end: {
          line: 60,
          column: 3
        }
      },
      "12": {
        start: {
          line: 59,
          column: 49
        },
        end: {
          line: 59,
          column: 72
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 48,
            column: 29
          },
          end: {
            line: 48,
            column: 30
          }
        },
        loc: {
          start: {
            line: 48,
            column: 40
          },
          end: {
            line: 52,
            column: 3
          }
        },
        line: 48
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 48,
            column: 40
          },
          end: {
            line: 48,
            column: 41
          }
        },
        loc: {
          start: {
            line: 49,
            column: 2
          },
          end: {
            line: 52,
            column: 3
          }
        },
        line: 49
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 56,
            column: 2
          },
          end: {
            line: 56,
            column: 3
          }
        },
        loc: {
          start: {
            line: 56,
            column: 14
          },
          end: {
            line: 60,
            column: 3
          }
        },
        line: 56
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 59,
            column: 11
          },
          end: {
            line: 59,
            column: 12
          }
        },
        loc: {
          start: {
            line: 59,
            column: 49
          },
          end: {
            line: 59,
            column: 72
          }
        },
        line: 59
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 59,
            column: 21
          },
          end: {
            line: 59,
            column: 42
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 59,
            column: 40
          },
          end: {
            line: 59,
            column: 42
          }
        }],
        line: 59
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    b: {
      "0": [0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "950ed8eaec4aa9e107d4c4cac44a9e8ef570e703"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1eiaa68uz9 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1eiaa68uz9();
;
var _ = (cov_1eiaa68uz9().s[0]++, {
  mapValues: _lodash.mapValues,
  zipObject: _lodash.zipObject
});
var _ref = (cov_1eiaa68uz9().s[1]++, _stylingConstants.default),
  color = _ref.color,
  font = _ref.font,
  border = _ref.border,
  spacing = _ref.spacing;
var _ref2 = (cov_1eiaa68uz9().s[2]++, _themeMapper.evolutionTheme),
  button = _ref2.button;
var BUTTON_LIGHTEN_AMOUNT = exports.BUTTON_LIGHTEN_AMOUNT = (cov_1eiaa68uz9().s[3]++, 0.2);
var BUTTON_DARKEN_AMOUNT = exports.BUTTON_DARKEN_AMOUNT = (cov_1eiaa68uz9().s[4]++, 0.1);
var THEME_PATH = exports.THEME_PATH = (cov_1eiaa68uz9().s[5]++, {
  borderRadius: 'theme.generalBorderRadius',
  padding: 'theme.inputAndButtonPadding',
  height: 'theme.inputAndButtonHeight',
  smallHeight: 'theme.smallButtonHeight',
  textButtonBorder: 'theme.buttonTextBorderStyle'
});
var DEFAULT_STYLING_CONSTANTS = exports.DEFAULT_STYLING_CONSTANTS = (cov_1eiaa68uz9().s[6]++, (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, {
  fontSize: font.sizeMS,
  bg: color.boxBackground,
  textColor: color.boxText,
  borderRadius: border.radiusNone,
  padding: "0 ".concat(spacing.medium),
  height: null,
  smallHeight: null
}), _themeProvider.TicketShopTheme.EVOLUTION, {
  fontSize: button.fontSize,
  bg: button.primary.bgColor,
  textColor: button.primary.color,
  borderRadius: 'var(--generalBorderRadius, 12px)',
  padding: '0 16px',
  height: 'var(--inputButtonHeight, 40px)',
  smallHeight: '30px'
}));
cov_1eiaa68uz9().s[7]++;
var evolutionActiveHover = function evolutionActiveHover(variant) {
  cov_1eiaa68uz9().f[0]++;
  cov_1eiaa68uz9().s[8]++;
  return function (props) {
    cov_1eiaa68uz9().f[1]++;
    cov_1eiaa68uz9().s[9]++;
    return _helpers.buttonVariantQueries[variant](_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n    background-color: ", ";\n    opacity: 0.6;\n  "])), (0, _helpers.getVariantBgColor)(props));
  };
};
var EVOLUTION_STATE_STYLES = exports.EVOLUTION_STATE_STYLES = (cov_1eiaa68uz9().s[10]++, _.mapValues(_.zipObject(_types.buttonVariants, _types.buttonVariants), function (variant) {
  cov_1eiaa68uz9().f[2]++;
  cov_1eiaa68uz9().s[11]++;
  return {
    hover: evolutionActiveHover(variant),
    active: evolutionActiveHover(variant),
    focus: function focus(_ref4) {
      var _ref4$theme = _ref4.theme,
        _ref4$theme2 = _ref4$theme === void 0 ? (cov_1eiaa68uz9().b[0][0]++, {}) : _ref4$theme,
        primaryColor = _ref4$theme2.primaryColor;
      cov_1eiaa68uz9().f[3]++;
      cov_1eiaa68uz9().s[12]++;
      return (0, _utils.boxShadow)(primaryColor);
    }
  };
}));